import React, {useEffect, useState} from 'react';
import {Dropdown} from '@priority-software/priority-style-react';
import List from '../../../../components/Common/List';
import {getLocalizedText, texts} from '../../../../constants/TextConst';
import {Label} from '../../../../components/Common/Label';

export const OptionsList = ({
    results,
    handleScroll,
    value,
    autoHeightMax = undefined,
    isLoading,
    renderDropdownItem,
    gradient,
    searchQuery,
    searchByTitle = null,
    isSearching
}) => {
    const [processedQuery, setProcessedQuery] = useState(searchQuery);

    useEffect(() => {
        if (!isSearching) {
            setProcessedQuery(searchQuery);
        }
    }, [isSearching]);

    return (
        <Dropdown.Section gradient={gradient}>
            {results.length > 0 && (
                <List
                    autoHeight
                    onScrollToEnd={handleScroll}
                    data={results}
                    extraData={value}
                    autoHeightMax={autoHeightMax}
                    renderItem={renderDropdownItem}
                />
            )}

            {results.length === 0 && !isLoading && gradient && (
                <Dropdown.Item closeOnClick={false}>
                    <Label componentClasses="no-results-label">
                        {searchByTitle
                            ? getLocalizedText(texts.noCategorySearchResults)?.replace(
                                  'XXX',
                                  processedQuery
                              )
                            : getLocalizedText(texts.noSearchResults)}
                    </Label>
                </Dropdown.Item>
            )}
        </Dropdown.Section>
    );
};
